import {HStack, Text} from "@chakra-ui/react";
import {MdDirectionsWalk} from "react-icons/md";
import BarLink from "../BarLink";
import {Bar} from "../../../interfaces/Bar";

export default function DistanceView({distance, bar}: {distance: number, bar?: Bar}) {
    return (
        <HStack justify="space-between">
            <HStack align="center">
                <MdDirectionsWalk/>
                <Text mb={0}>
                    {Intl.NumberFormat("lv-LV", {maximumFractionDigits: 1}).format(distance)} km away
                </Text>
            </HStack>
            {bar && <BarLink bar={bar} onlyIcon={true}/> }
        </HStack>
    )
}